export default __webpack_public_path__ + "static/media/category-company.0f95a713.jpg";